import { Mail, Phone, MapPin, MessageCircle, Clock } from "lucide-react";
import Reveal from "../components/Reveal";
import Seo from "../components/Seo";
import QuoteForm from "../components/QuoteForm";
import { BRAND } from "../data/brand";

export default function Contact() {
  return (
    <div>
      <Seo
        title="Contact the Voyage Luxe Concierge — Quote within 24 Hours"
        description="Speak with our concierge desk. Phone, WhatsApp, email, or visit our Delhi atelier by appointment. A private quote within 24 hours."
      />
      {/* Hero */}
      <section className="pt-40 md:pt-48 pb-12 container-luxe">
        <div className="eyebrow mb-6">Concierge Desk</div>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-balance max-w-5xl">
          The first<br /><span className="italic">conversation</span>.
        </h1>
        <p className="mt-8 text-foreground/70 max-w-2xl leading-relaxed">
          Every journey begins with a quiet conversation. Tell us about yours — by form, by phone, or in person at our Delhi atelier.
        </p>
      </section>

      {/* Quick contacts */}
      <section className="py-12 container-luxe">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border">
          {[
            { icon: Phone, l: "Call", v: BRAND.phone, href: BRAND.phone_link, sub: "+1 / +44 lines available" },
            { icon: MessageCircle, l: "WhatsApp", v: "+91 9555647288", href: BRAND.whatsapp_link, sub: "Reply within minutes" },
            { icon: Mail, l: "Email", v: BRAND.email, href: `mailto:${BRAND.email}`, sub: "24-hour reply" },
          ].map((c, i) => (
            <Reveal key={c.l} delay={i * 80}>
              <a href={c.href} target={c.icon === MessageCircle ? "_blank" : undefined} rel="noopener noreferrer" data-testid={`contact-${c.l.toLowerCase()}`} className="block bg-background p-8 md:p-10 hover:bg-secondary/50 transition-colors">
                <c.icon size={22} strokeWidth={1.25} className="text-accent" />
                <div className="eyebrow mt-5">{c.l}</div>
                <div className="font-serif text-2xl md:text-3xl mt-2">{c.v}</div>
                <div className="mt-2 text-sm text-foreground/55">{c.sub}</div>
              </a>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Form + Map */}
      <section className="py-16 md:py-24 container-luxe">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <Reveal className="lg:col-span-7">
            <div className="eyebrow mb-4">Request a Curated Quote</div>
            <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight mb-10 text-balance">
              A private proposal within <span className="italic text-accent">24 hours</span>.
            </h2>
            <QuoteForm />
          </Reveal>

          <Reveal className="lg:col-span-5" delay={200}>
            <div className="border border-border">
              <div className="aspect-[4/3] overflow-hidden">
                <iframe
                  title="Voyage Luxe Atelier"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.234!2d77.21!3d28.61!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDM2JzM2LjAiTiA3N8KwMTInMzYuMCJF!5e0!3m2!1sen!2sin!4v1700000000000"
                  width="100%" height="100%" style={{ border: 0, filter: "grayscale(0.4) contrast(1.05)" }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="w-full h-full"
                />
              </div>
              <div className="p-8">
                <div className="eyebrow text-foreground/55 mb-3">Voyage Luxe Atelier</div>
                <div className="font-serif text-2xl leading-tight">11 Aurangzeb Road<br />New Delhi 110011, India</div>
                <div className="mt-6 space-y-3 text-sm text-foreground/70">
                  <div className="flex items-center gap-3"><Clock size={14} strokeWidth={1.25} /> Mon – Sat · 09:30 – 19:00 IST</div>
                  <div className="flex items-center gap-3"><MapPin size={14} strokeWidth={1.25} /> By appointment only</div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
